/* tslint:disable */
/* eslint:disable */
/**
* @typedef {Object} settingsChangedParams
* @property {string} appName - Application Name
* @property {string} category - Settings panel tab
* @property {string} componentId - ID of the component in Dev Center
* @property {string} componentName - Name of the component in Dev Center
* @property {boolean} isMobile - Event sent from a mobile form factor
* @property {string} origin - editor/editor_x/ADI
* @property {string} parameter - Name of the field
* @property {string} value - Updated value
**/
/**
 * Name: Settings Changed. Evid: 200.
 * Event description: Component configuration was changed via Settings panel.

 * appName - Type: string. Desc: Application Name
 *
 * category - Type: string. Desc: Settings panel tab
 *
 * componentId - Type: string. Desc: ID of the component in Dev Center
 *
 * componentName - Type: string. Desc: Name of the component in Dev Center
 *
 * isMobile - Type: bool. Desc: Event sent from a mobile form factor
 *
 * origin - Type: string. Desc: editor/editor_x/ADI
 *
 * parameter - Type: string. Desc: Name of the field
 *
 * value - Type: string. Desc: Updated value
 * @param {settingsChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var settingsChanged = function (params) {
    return { evid: 200, src: 127, endpoint: 'settings', params: params };
};
/**
* @typedef {Object} settingsTabClickedParams
* @property {string} appName - Application Name
* @property {string} componentId - ID of the component in Dev Center
* @property {string} componentName - Name of the component in Dev Center
* @property {boolean} isMobile - Event sent from a mobile form factor
* @property {string} origin - editor/editor_x/ADI
* @property {string} tabName - Name of the clicked tab
**/
/**
 * Name: Settings Tab Clicked. Evid: 201.
 * Event description: Settings panel left-side tab was clicked..

 * appName - Type: string. Desc: Application Name
 *
 * componentId - Type: string. Desc: ID of the component in Dev Center
 *
 * componentName - Type: string. Desc: Name of the component in Dev Center
 *
 * isMobile - Type: bool. Desc: Event sent from a mobile form factor
 *
 * origin - Type: string. Desc: editor/editor_x/ADI
 *
 * tabName - Type: string. Desc: Name of the clicked tab
 * @param {settingsTabClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var settingsTabClicked = function (params) {
    return { evid: 201, src: 127, endpoint: 'settings', params: params };
};
//# sourceMappingURL=index.js.map